import React, { Component } from 'react';
import { Route, Link, withRouter } from 'react-router-dom';
import { Container, Image, Menu, Segment, Grid, Header } from 'semantic-ui-react'

import './App.css';

import HomePage from './pages/home-page'
import SchedulePage from './pages/schedule-page'
import ReadingCommentariesPage from './pages/reading-commentaries-page';
import LeadingDiscussionsPage from './pages/leading-discussions-page';
import ExperienceLogPage from './pages/experience-log-page';
import GroupProjectPage from './pages/group-project-page';

import IndividualIdeationPage from './pages/group-project-assignments/individual-ideation-page';
import GroupIdeationPage from './pages/group-project-assignments/group-ideation-page';
import ProposalsPage from './pages/group-project-assignments/proposals-page';
import ProgressReportsPage from './pages/group-project-assignments/progress-reports-page';
import FinalPresentationPage from './pages/group-project-assignments/final-presentation-page';
import FinalPaperPage from './pages/group-project-assignments/final-paper-page';

import scheduleData from './data/schedule';

class App extends Component {
  componentDidMount() {
    document.title = "CS4/8803 UPS | Spring 2022"
  }

  render() {
    return (
      <div>
        <Menu fixed='top' stackable>
          <Container>
            <Menu.Item as='a' href="/" header>
              CS 4/8803 UPS - Spring 2022
            </Menu.Item>
            <Menu.Item as='a' href="/schedule">Schedule</Menu.Item>
            <Menu.Item as='a' href="/commentaries">Reading Commentaries</Menu.Item>
            <Menu.Item as='a' href="/discussions">Leading Discussions</Menu.Item>
            <Menu.Item as='a' href="/group-project">Group Project</Menu.Item>
          </Container>
        </Menu>

        <Container style={{ marginTop: '4em' }}>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/schedule" component={SchedulePage} data={scheduleData} />
          <Route exact path="/commentaries" component={ReadingCommentariesPage} />
          <Route exact path="/discussions" component={LeadingDiscussionsPage} />
          <Route exact path="/experience-log" component={ExperienceLogPage} />
          <Route exact path="/group-project" component={GroupProjectPage} />

          <Route exact path="/individual-ideation" component={IndividualIdeationPage} />
          <Route exact path="/group-ideation" component={GroupIdeationPage} />
          <Route exact path="/proposals" component={ProposalsPage} />
          <Route exact path="/progress-reports" component={ProgressReportsPage} />
          <Route exact path="/final-presentation" component={FinalPresentationPage} />
          <Route exact path="/final-paper" component={FinalPaperPage} />
        </Container>

        <Segment
          inverted
          vertical
          style={{ margin: '5em 0em 0em', padding: '5em 0em' }}
        >
          <Container textAlign='left'>
            <Grid divided inverted stackable>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Header inverted as='h4' content='Instructor' />
                  <p>
                    <b>Name: </b>
                    Sauvik Das
                  </p>
                  <p>
                    <b>Email: </b>
                    sauvik[at]gatech.edu
                  </p>
                  <p>
                    <b>Office Hours: </b>
                      By appointment
                  </p>
                  <p>
                    <b>Office: </b>
                    TSRB 246 (The building with Moe's in it.)
                  </p>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Header inverted as='h4' content='Location & Time' />
                  <p>
                    <b>Room: </b>
                    Howey Physics S105A
                  </p>
                  <p>
                    <b>Times: </b>
                    TR 2:00 - 3:15
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </div>
    );
  }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/App.js